import { useEffect, useState } from 'react';
import Tabs from '../../../../Components/Tabs'
import { useLocation, useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import Table from './Table'
import GetIcon from '../../../../utils/Icon'
import Button from '../../../../Core/Button/Button'
import printerimg from "../../../../assets/print.png"
import { useGetDeliveryNoteDocQuery } from '../../../../store/api/deliveryNoteApi'
import {
    usePostCreatePackingSlipMutation, usePostSubmitPackingSlipMutation,
    usePostGetPackingSlipByNameMutation, useLazyGetPackingSlipCountQuery, usePostUpdatePackingSlipMutation
} from '../../../../store/api/packingSlip'
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import PrintModal from "../../../../../src/Core/Print/PrintModal";
import Attachment from '../../../../utils/Attachment';
import { usePostPurchaseOrderIDMutation } from '../../../../store/api/purchaseorderapi';
import { useGetDeliveryNoteIDTwoListMutation } from '../../../../store/api/deliveryNoteApi';
function Createpackingslip() {


    const nvg = useNavigate()

    const location = useLocation();
    // const deliveryNoteId = location.state?.deliveryNoteId;
    console.log("location.state?.deliveryNoteId",location.state)
    const [item, setItem] = useState(false)
    const [buttonData, setButtonData] = useState(false)
    const [activityboll, setactivityboll] = useState(false)
    const [tab, settab] = useState(1)
    const [item_Rows, setitem_Rows] = useState([]);

    const [itemList, setItemList] = useState([]);
    const [ptype, setptype] = useState("Error")
    const [loader, setloader] = useState(true)
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [scanInput, setScanInput] = useState("");
    const [save, setsave] = useState(false);
    const [pack_slip, setpack_slip] = useState('');
    const [fullDataState, setFullDataState] = useState(null);
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [packslipId, setPackslipId] = useState('')
    
    const [deliveryNoteId, setdeliveryNoteId] = useState(location?.state?.deliveryNoteId ? location?.state?.deliveryNoteId : '');

        useEffect(()=>{
       if(location?.state?.deliveryNoteId){
        setdeliveryNoteId(location?.state?.deliveryNoteId);
        }
    },[location?.state?.deliveryNoteId])


    console.log("check id is here",deliveryNoteId);
    const [deliveryNoteList, setdeliveryNoteList] = useState([]);
    // const [getAllDeliveryNote] = usePostPurchaseOrderIDMutation();
    const [getAllDeliveryNote] = useGetDeliveryNoteIDTwoListMutation();
    const { data: fulldata, isLoading, isError, errorr, refetch } = useGetDeliveryNoteDocQuery(deliveryNoteId);
    console.log("deliveryNoteIddeliveryNoteIddeliveryNoteIddeliveryNoteIddeliveryNoteIddeliveryNoteId123",fulldata);

        useEffect(()=>{
//   if(!selectedpicklist){
       const getpicklistfun = async () =>{

        //  const formData = new FormData();
        //  formData.append("doctype", "Delivery Note");
        //  formData.append("fields", JSON.stringify(["name"]));
        //  formData.append("filters", JSON.stringify([["Delivery Note","status","=","To Bill"],["Delivery Note","return_against","is","not set"]]));
        //  formData.append("order_by", "modified desc");
        //  formData.append("view", "List");
        //  formData.append("start",0);
        //  formData.append("view",9999999);


         const response = await getAllDeliveryNote({status:0, isReturn : 0}).unwrap();
         console.log("fkkfkfkfkf",response);

          const temp = response?.message?.values || [];
            console.log("Temp Result",temp)
            const idList = temp.map(item => ({ name: item[0] })); // since fields = ["name"]
            setdeliveryNoteList(idList);
        // const names = getpo?.data?.message?.values.map((item) => ({ name: item[0] }));
        //  setdeliveryNoteList(names)
        }

        getpicklistfun();
    // }
  },[])


  useEffect(()=>{
    console.log("deliveryNoteIddeliveryNoteIddeliveryNoteIddeliveryNoteIddeliveryNoteIddeliveryNoteId",deliveryNoteId);
     refetch()
  },[deliveryNoteId])


    useEffect(() => {
        if (!isLoading && fulldata?.docs?.length) {
            setFullDataState(fulldata);

            const updatedRows = fulldata.docs[0].items.map(item => ({
                ...item,
                scan_qty: 0,
                qty: item.qty - item.packed_qty,
            }));

            setItemList(updatedRows);
            const allQtyZero = updatedRows.every(item => item.qty === 0);

            if (allQtyZero) {
                console.log(deliveryNoteId,"deliveryNoteId");
                // console.log(fullDataState?.docs?.[0]?.name,"     fullDataState.docs[0].name");
            
                
                // nvg('/outbound/outbound-packingslip', { deliveryNoteId: deliveryNoteId });
            }
        } else {
            console.log("Waiting or no data", { isLoading, fulldata });
        }
    }, [isLoading, fulldata]);

    const [selectedItem, setSelectedItem] = useState(null);

    const handleScan = (scannedCode) => {
        setItemList(prevList => {
            let itemFound = false;
            let updatedItem = null;

            const updatedList = prevList.map(item => {
                if (item.item_code === scannedCode) {
                    itemFound = true;
                    if (item.scan_qty < item.qty) {
                        updatedItem = {
                            ...item,
                            scan_qty: parseInt(item.scan_qty) + 1
                        };
                        return updatedItem;
                    } else {
                        setptype("Error");
                        setError(`All quantities already scanned for item ${item.item_code}`);
                        setShowError(true);
                    }
                }
                return item;
            });

            if (itemFound && updatedItem) {
                // Move updated item to first position
                const newList = [
                    updatedItem,
                    ...updatedList.filter(i => i.item_code !== scannedCode)
                ];
                setSelectedItem(updatedItem); // if you're tracking it separately
                return newList;
            }

            if (!itemFound) {
                setTimeout(() => {
                    setptype("Error");
                    setError(`Item ${scannedCode} not found in the list`);
                    setShowError(true);
                }, 0);
            }

            return updatedList;
        });

        setTimeout(() => {
            setScanInput("");
        }, 400);
    };

    const [postCreatePackingSlip] = usePostCreatePackingSlipMutation();
    const [getPackingSlipByName] = usePostGetPackingSlipByNameMutation();
    const [postUpdatePackingSlip] = usePostUpdatePackingSlipMutation();

    const handleSaveClick = async () => {
        try {


            // const payloadItems = item_Rows

            //     .map(item => ({
            //         item_code: item.item_code,
            //         qty: Number(item.scan_qty)
            //         // qty: item.qty

            //     }));

            const payload = {
                delivery_note_id: deliveryNoteId,
            };

            const response = await postCreatePackingSlip(payload).unwrap();
            console.log("check response osf dkdkd",response);
            if (response.result) {
                setError('Submited');
                setptype(`Packing Slip Created ${response.result.packing_slip_id} successfully:`);
                setShowError(true);

                setsave(false)
                setsave(true)
                console.log(response, "response_one");
                setpack_slip(response.result.packing_slip_id)
                setFullDataState(response)
                triggerGetCount(deliveryNoteId);
                const name = response.result.packing_slip_id;
                const detailResponse = await getPackingSlipByName({ doctype: 'Packing Slip', name }).unwrap();
                const createdItems = detailResponse.message.items;

                const updatedItems = item_Rows.map(localItem => {
                    const match = createdItems.find(remoteItem =>
                        remoteItem.item_code === localItem.item_code 
                        // && remoteItem.batch_no === localItem.batch_no
                    );

                    return {
                        ...localItem,
                        dn_detail: match ? match.dn_detail : null,
                    };
                });

                setitem_Rows(updatedItems);
                console.log(updatedItems, "updated item_Rows with dn_detail");

                // here call update api
                const updatePayload = {
                    packing_slip_id: name,
                    items: updatedItems
                        .filter((item) => item.dn_detail)
                        .map((item) => ({
                            dn_detail: item.dn_detail,
                            qty: Number(item.scan_qty),
                        })),
                };
                
                const updateResponse = await postUpdatePackingSlip(updatePayload).unwrap();
                console.log("Packing Slip Updated:", updateResponse);
            }



        } catch (error) {
            console.error('Error creating packing slip:', error.data.message);
            // alert('Failed to create packing slip');
            setptype('Error');
            setError(`Error creating packing slip: ${error.data.message}`);
            setShowError(true);

        }
    };

    const [submitPackingSlip] = usePostSubmitPackingSlipMutation();
    const [triggerGetCount, { data: countData, isLoading: countLoading, error: countError }] = useLazyGetPackingSlipCountQuery();

    const handleKeyDown =(e) =>{
        if (e.key === "Enter") {
            handleScan(scanInput);
            console.log("Enter Pressed")
        }
    }
    const handleSubmit = async () => {
        try {
            const response = await submitPackingSlip({
                packing_slip_id: pack_slip
            }).unwrap();
            setError('Submited');
            setptype('Packing Slip  submitted successfully:');
            setShowError(true);
            setsave(false)
            const refetchResult = await refetch();

            if (refetchResult?.data) {
                const freshData = refetchResult.data;
                setFullDataState(freshData);
                const updatedRows = freshData.docs[0].items.map(item => ({
                    ...item,
                    scan_qty: 0,
                    qty: item.qty - item.packed_qty
                }));
                setItemList(updatedRows);

                const allPacked = freshData.docs[0]?.items?.every(item => {
                    const qty = Number(item.qty);
                    const packed = Number(item.packed_qty);
                    return qty === packed;
                });

                console.log(allPacked, "✅ allPacked_after_submit");

                if (allPacked) {
                    console.log("✅ Navigating to packing slip page");
                    nvg('/outbound/outbound-packingslip', { state: { deliveryNoteId } });
                }
            }
            console.log('Submit Success:', response);
        } catch (err) {
            console.error('Submit Failed:', err);
        }
    };
    const lineCount = itemList.length;
    const totalQuantity = itemList.reduce((sum, item) => sum + (item.qty || 0), 0);
    const scannedQuantity = itemList.reduce((sum, item) => sum + parseInt(item.scan_qty || 0, 10), 0);


    const refreshAndSetData = async (refetch, setFullDataState, setItemList) => {
        try {
            const refetchResult = await refetch();

            if (refetchResult?.data) {
                const freshData = refetchResult.data;

                // Update full data state
                setFullDataState(freshData);

                // Prepare updated items with modified qty and scan_qty
                const updatedRows = freshData.docs[0].items.map(item => ({
                    ...item,
                    scan_qty: 0,
                    qty: item.qty - item.packed_qty,
                }));
                setItemList(updatedRows);

                // Check if all items are fully packed
                const allPacked = freshData.docs[0].items.every(item => {
                    const qty = Number(item.qty);
                    const packed = Number(item.packed_qty);
                    return qty === packed;
                });

                return allPacked;
            }
        } catch (error) {
            console.error("Error during refetch and update:", error);
            return false;
        }
    };

    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between p-2 " style={{ background: "#fcfdfe", height: '40px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0"> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/outbound-packingslip')}>Packing Slip List  </p>
                    <p className="m-0">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79" }} >
                        New Packing Slip
                        <button
                            className={` ${buttonData
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {buttonData ? 'Submitted' : item ? 'Draft' : 'New'}
                        </button>
                    </a>
                </div>
                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
                        {!save && (
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={handleSaveClick}
                        >
                            Save
                        </Button>
                    )}


                    {save && (
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={handleSubmit}
                        >
                            Submit
                        </Button>
                    )}

                    {save && (
                        <p className="p-0 m-0">
                            <img src={printerimg}
                                onClick={() => setShowPrintModal(true)}
                                className="px-2" style={{ width: '35px', cursor: 'pointer' }} alt="404" />
                        </p>

                    )}

                </div>
            </div>

            <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                        </ul>
                        {pack_slip && <Attachment doctype="Packing Slip" docname={pack_slip} />}
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px', flexGrow: '1' }}>
                    <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1
                        detail={{
                            deliveryNoteList,
                            deliveryNoteId,
                            setdeliveryNoteId
                        }} 
                        
                        fullDataState={fullDataState} activityboll={activityboll} pack_slip={pack_slip} />

                    </div>
                    <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <div className="d-flex justify-content-between align-items-center pb-2" style={{ gap: '5px' }}>

                            <div className="d-flex" style={{ gap: '5px' }}>
                                <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {lineCount}</span></p>
                                <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}>{totalQuantity}</span></p>
                                <p className="ReceivedQty">Scanned Quantity -  <span style={{ color: '#0a0a1a' }}>{scannedQuantity}</span></p>
                                {countData && countData.message !== undefined && (
                                    <p
                                        className="ReceivedQty"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => nvg('/outbound/outbound-packingslip', { state: { deliveryNoteId } })}
                                    >
                                        Packing slip Count - <span style={{ color: '#fd8c5c' }}>{countData.message}</span>
                                    </p>
                                )}



                            </div>
                            <div className="px-2 d-flex pb-2" style={{ width: '280px' }}>
                                <input
                                    type="text"
                                    className="form-control p-0 px-2"
                                    placeholder="Scan Item"
                                    value={scanInput}
                                    onChange={e => setScanInput(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                    style={{ fontSize: '0.8rem', height: '34px' }}
                                />
                                <span
                                    style={{ position: 'relative', left: '-28px', top: '3px', cursor: 'pointer' }}
                                >
                                    <GetIcon iconName="BsUpcScan" size={15} color="#FF8D5C" />
                                </span>
                            </div>



                        </div>



                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', fontSize: '15px', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table

                            list_data={itemList}
                            fulldata={fulldata}
                            row={{ Rows: item_Rows, setRows: setitem_Rows, selectedItem }}
                            save={save}
                        />
                    </div>

                </div>
                {showPrintModal && (
                    <PrintModal
                        onClose={() => setShowPrintModal(false)}
                        documentId={pack_slip}
                        doctype="Packing Slip"
                        title="Print Packing Slip"
                    />
                )}


                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />

            </div>
        </>
    )
}

export default Createpackingslip